import React, { useEffect, useState } from "react";

export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, pct)));
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-1 z-[80] bg-transparent pointer-events-none"
    >
      <div
        className="h-full bg-[#0F0F0F]"
        style={{ width: `${progress}%`, transition: "width 80ms linear" }}
      />
    </div>
  );
}
